import { useEffect, useMemo, useState } from "react";
import { apiGet } from "../../lib/apiClient";

export function usePaidBookingStats({ enabled = true } = {}) {
  const [stats, setStats] = useState({
    paidBookings: 0,
    paidAttendees: 0,
    accommodation: { room: 0, camper: 0, camp: 0, none: 0 },
  });
  const [loading, setLoading] = useState(Boolean(enabled));
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;

    async function load() {
      if (!enabled) return;

      setLoading(true);
      setError("");

      try {
        const data = await apiGet("/.netlify/functions/booking-paid-stats");

        if (cancelled) return;
        setStats({
          paidBookings: Number(data.paidBookings || 0),
          paidAttendees: Number(data.paidAttendees || 0),
          accommodation: data.accommodation || { room: 0, camper: 0, camp: 0, none: 0 },
        });
      } catch (e) {
        if (cancelled) return;
        setError(e?.message || "Failed to load booking stats");
        setStats({
          paidBookings: 0,
          paidAttendees: 0,
          accommodation: { room: 0, camper: 0, camp: 0, none: 0 },
        });
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  const memoStats = useMemo(() => stats, [stats]);

  return {
    ...memoStats,
    loading,
    error,
  };
}
